module.exports = __webpack_public_path__ + "img/default-waves.755982eb.svg";